<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        v-bind="$attrs"
        disable-resize-watcher
        :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }"
        right
        hide-overlay
        :width="panelWidth"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <div class="d-flex justify-space-between align-center">
              <v-icon @click="drawer = false">mdi-arrow-right</v-icon>
              <span>Filtry</span>
              <v-btn
                  color="primary"
                  icon
                  @click="clearFilters"
              >
                <v-icon>mdi-filter-remove</v-icon>
              </v-btn>
            </div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list dense>
        <v-list-item class="pa-0 mb-2" v-for="(v, k) in filters" :key="k">
          <div style="width: 100%">
            <v-card-title
                v-if="v.type !== 'PANEL'"
                style="text-transform:none!important; line-height: 15px; font-size: 15px" class="pb-1 pt-0"
            >
              {{ v.text }}
            </v-card-title>
            <v-card-text class="py-0">
              <!--ONLY RSQL-->
              <div v-if="v.type === 'CHECKBOX'">
                <v-checkbox
                    v-if="!v.elements"
                    class="py-0 ma-0 pa-0"
                    :value="v.value"
                    v-model="v.filter"
                    :label="checkbox.text"
                    hide-details
                />
                <v-checkbox
                    v-else
                    v-for="(checkbox, key) in v.elements" :key="key"
                    class="py-0 ma-0 pa-0"
                    v-model="checkbox.filter"
                    :value="checkbox.value"
                    :label="checkbox.text"
                    hide-details
                />
              </div>

              <div v-if="v.type === 'RADIO'">
                <v-card-text class="py-0 ma-0 pa-0">
                  <v-radio-group
                      v-model="v.filter"
                      column
                  >
                    <v-checkbox
                        v-for="(radio, key) in v.radioGroup" :key="key"
                        :label="radio.text"
                        v-model="v.filter"
                        :value="radio.value"
                    />
                  </v-radio-group>
                </v-card-text>
              </div>

              <div v-if="v.type === 'BOOLEAN'">
                <tcn-switch :vt="v"></tcn-switch>
              </div>

              <div v-if="v.type === 'TEXT' || v.type === 'NUMBER'">
                <v-card-text class="py-0 ma-0 pa-0">
                  <v-text-field
                      @keyup.enter="reload(true)"
                      :type="v.type"
                      :placeholder="v.text +'...'"
                      v-model="v.filter"
                      outlined
                      dense
                      hide-details
                  />
                </v-card-text>
              </div>

              <div v-if="v.type === 'AUTOCOMPLETE'">
                <v-autocomplete
                    :label="v.label"
                    hide-details
                    v-model="v.filter"
                    :items="v.items"
                    :item-text="v.itemText"
                    :item-value="v.itemValue"
                    dense
                    outlined
                    clearable
                />
              </div>

              <div
                  v-if="v.type === 'DATE' || v.type === 'DATETIME' || v.type === 'DATETIME-LOCAL' || v.type === 'TIME'">
                <v-card-text class="py-0 ma-0 pa-0">

                  <v-text-field
                      @keyup.enter="reload(true)"
                      v-if="!v.elements"
                      class="mb-1 mt-1"
                      :type="v.type"
                      v-model="v.filter"
                      outlined
                      dense
                      hide-details
                      persistent-placeholder
                  />

                </v-card-text>
              </div>

              <!--ONLY RSQL-->
              <div v-if="v.type === 'DATE-NO-RANGE'">
                <v-card-text class="py-0 ma-0 pa-0">
                  <data-range
                      :range="false"
                      :vt="v"
                  ></data-range>
                </v-card-text>
              </div>
              <div v-if="v.type === 'DATE-RANGE'">
                <v-card-text class="py-0 ma-0 pa-0">
                  <data-range
                      :range="true"
                      :vt="v"
                  ></data-range>
                </v-card-text>
              </div>

              <div v-if="v.type === `DATE-AND-TIME`">
                <v-card-text  class="py-0 ma-0 pa-0">
                  <DateAndTimePicker
                      :vt="v"
                      class="customLabel"
                  />
                </v-card-text>
              </div>

              <div v-if="v.type === 'PANEL'">
                <v-expansion-panels
                    flat
                    class="condensed"
                >
                  <v-expansion-panel
                  >
                    <v-expansion-panel-header style="text-transform: uppercase">
                      {{ v.text }}
                    </v-expansion-panel-header>
                    <v-divider/>
                    <v-expansion-panel-content>
                      <div
                          v-for="(vt, i) in v.children"
                          :key="i"
                      >
                        <!--ONLY RSQL-->
                        <div v-if="vt.type === 'CHECKBOX'">
                          <v-checkbox
                              v-if="!vt.elements"
                              class="py-0 ma-0 pa-0"
                              :value="vt.value"
                              v-model="vt.filter"
                              :label="checkbox.text"
                              hide-details
                          />
                          <v-checkbox
                              v-else
                              v-for="(checkbox, key) in vt.elements" :key="key"
                              class="py-0 ma-0 pa-0"
                              v-model="checkbox.filter"
                              :value="checkbox.value"
                              :label="checkbox.text"
                              hide-details
                          />
                        </div>

                        <div v-if="vt.type === 'RADIO'">
                          <v-card-text class="py-0 ma-0 pa-0">
                            <v-radio-group
                                v-model="vt.filter"
                                column
                            >
                              <v-checkbox
                                  v-for="(radio, key) in vt.radioGroup" :key="key"
                                  :label="radio.text"
                                  v-model="vt.filter"
                                  :value="radio.value"
                              />
                            </v-radio-group>
                          </v-card-text>
                        </div>

                        <div v-if="vt.type === 'BOOLEAN'">
                          <tcn-switch :vt="v"></tcn-switch>
                        </div>


                        <div v-if="vt.type === 'TEXT' || vt.type === 'NUMBER'">
                          <v-card-text class="py-0 ma-0 pa-0">
                            <v-text-field
                                @keyup.enter="reload(true)"
                                :type="vt.type"
                                :placeholder="vt.text +'...'"
                                v-model="vt.filter"
                                outlined
                                dense
                                hide-details
                                class="my-2"
                            />
                          </v-card-text>
                        </div>

                        <div v-if="vt.type === 'AUTOCOMPLETE'">
                          <v-autocomplete
                              :label="vt.label"
                              hide-details
                              v-model="vt.filter"
                              :items="vt.items"
                              :item-text="vt.itemText"
                              :item-value="vt.itemValue"
                              dense
                              outlined
                              clearable
                          />
                        </div>

                        <div
                            v-if="vt.type === 'DATE' || vt.type === 'DATETIME' || vt.type === 'DATETIME-LOCAL' || vt.type === 'TIME'">
                          <v-card-text class="py-0 ma-0 pa-0">

                            <v-text-field
                                v-if="!vt.elements"
                                class="mb-1 mt-1"
                                :type="vt.type"
                                v-model="vt.filter"
                                outlined
                                dense
                                hide-details
                                persistent-placeholder
                            />

                          </v-card-text>
                        </div>

                        <!--ONLY RSQL-->
                        <div v-if="vt.type === 'DATE-RANGE'">
                          <v-card-text class="py-0 ma-0 pa-0">
                            <data-range
                                :vt="vt"
                            ></data-range>
                          </v-card-text>
                        </div>

                        <div v-if="v.type === `DATE-AND-TIME`">
                          <v-card-text  class="py-0 ma-0 pa-0">
                            <DateAndTimePicker
                                :vt="v"
                                class="customLabel"
                            />
                          </v-card-text>
                        </div>

                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-card-text>
          </div>
        </v-list-item>
      </v-list>
      <div style="display: flex; justify-content: right; padding-right: 20px">
      <slot name="filterBtn" :reload="reload">
        <v-btn
            small
            color="primary"
            style="color: white; text-transform: none!important;"
            @click="reload(true)"
        >
          <slot name="btnLabel">
            Filtruj
          </slot>
        </v-btn>
      </slot>
      </div>
    </v-navigation-drawer>

    <v-btn
        :icon="!outlined"
        :small="outlined"
        :outlined="outlined"
        :text="outlined"
        @click.stop="drawer = !drawer"
    >
      <v-icon>mdi-filter-outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
import {buildTcnFilter} from "./parserTcnFilter";
import {DataRange, TcnSwitch} from "./TcnField";
import LZString from "./lzstring/lz-string"
import DateAndTimePicker from "./TcnField/DateAndTimePicker";

export default {
  name: "TcnFilter",
  props: ["rows", "panelWidth","outlined"],
  components: {DateAndTimePicker, TcnSwitch, DataRange},
  data() {
    return {
      filters: [],
      drawer: false,
      firstVisit: true,
      filter: '',
    }
  },
  methods: {

    reload(setFiltersToUrl) {
      function getIdAndValueOfFilter(filters, filterById) {
        for (const e of filters) {
          if (e.type === "CHECKBOX") {
            getIdAndValueOfFilter(e.elements, filterById)
          } else if (e.type === "PANEL") {
            getIdAndValueOfFilter(e.children, filterById)
          } else {
            if (e.filter) {
              filterById.set(e.id, e.filter)
            }
          }
        }
      }

      if (setFiltersToUrl) {
        const filterById = new Map()
        getIdAndValueOfFilter(this.filters, filterById);
        let compressedFilters = LZString.compressToBase64(JSON.stringify(Object.fromEntries(filterById)));
        this.$router
            .push({
              query: {
                ...this.$route.query,
                c: compressedFilters
              }
            })
            .catch(error => {
              console.log(error);
            });
      }

      this.filter = buildTcnFilter(this.filters)
      this.setFilters(this.filter)
    },

    clearFilters() {
      this.filters = JSON.parse(JSON.stringify(this.rows))
      this.reload(true)
    },

    setFilters(val) {
      this.$emit('update:filterByQuery', val)
    },

    setFiltersInComponent: function (filtersObject) {
      function setValueToFilter(filters, filterById) {
        for (const e of filters) {
          if (e.type === "CHECKBOX") {
            setValueToFilter(e.elements, filterById)
          } else if (e.type === "PANEL") {
            setValueToFilter(e.children, filterById)
          } else {
            if (filterById[e.id]) {
              e.filter = filterById[e.id]
            } else {
              e.filter = null
            }
          }
        }
      }

      if (this.$route && "c" in this.$route.query) {
        this.filters = JSON.parse(JSON.stringify(filtersObject))
        setValueToFilter(this.filters, JSON.parse(LZString.decompressFromBase64(this.$route.query.c)))
      } else {
        this.filters = JSON.parse(JSON.stringify(filtersObject))
      }

      this.reload(false)
    },

  },

  watch: {
    rows: {
      handler: function () {
        this.setFiltersInComponent(this.rows)
      },
      deep: true,
    },
    '$route.query.c': {
      handler: function () {
        if (!this.firstVisit) {
          this.setFiltersInComponent(this.rows)
        } else {
          this.firstVisit = false
        }
      },
      deep: true,
    }
  },

  mounted() {
    this.setFiltersInComponent(this.rows);
  },

}
</script>

<style scoped lang="scss">
.v-navigation-drawer {
  z-index: 2 !important;
}

.v-expansion-panels.condensed .v-expansion-panel-header {
  min-height: 48px;
  max-height: 48px;
  padding: 0px 0;
}

.v-expansion-panels.condensed
.v-expansion-panel--active
.v-expansion-panel-header {
  padding-top: 2px;
  padding-bottom: 2px;
}

.v-expansion-panels.condensed .v-expansion-panel--active:not(:first-child),
.v-expansion-panels.condensed .v-expansion-panel--active + .v-expansion-panel {
  margin-top: 4px;
}

> > > .v-expansion-panel-content__wrap {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px;
}
</style>
